import { render, staticRenderFns } from "./buttonsave.vue?vue&type=template&id=8c34bc4e&"
import script from "./buttonsave.js?vue&type=script&lang=js&"
export * from "./buttonsave.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c34bc4e')) {
      api.createRecord('8c34bc4e', component.options)
    } else {
      api.reload('8c34bc4e', component.options)
    }
    module.hot.accept("./buttonsave.vue?vue&type=template&id=8c34bc4e&", function () {
      api.rerender('8c34bc4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/buttons/buttonsave.vue"
export default component.exports